import { isFeatureEnabled } from 'owa-feature-flags';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import {
    UnifiedGroupIdentity,
    UnifiedGroupIdentityType,
    GetUnifiedGroupDetailsJsonResponse,
    UnifiedGroupDetailsAdditionalPropertyType,
    UnifiedGroupDetailsResponseShape,
    getServiceAsync,
} from '../../../../service';
import { getGroupOwsOptions } from '../utils/groupsOwsUtils';
import { runOwsRequestWithMonitor, Feature } from '../../../../shared';

export function createGroupDetailsRequest(
    groupSmtp: string,
    groupId?: string,
    tenantId?: string
): Promise<GetUnifiedGroupDetailsJsonResponse> {
    const groupIdentity: UnifiedGroupIdentity =
        isFeatureEnabled('grp-useEOIDAsIdentityForGroupsAPIs') && groupId
            ? {
                  Type: UnifiedGroupIdentityType.ExternalDirectoryObjectId,
                  Value: groupId,
              }
            : {
                  Type: UnifiedGroupIdentityType.SmtpAddress,
                  Value: groupSmtp,
              };
    var prefixedId = groupSmtp;
    if (isFeatureEnabled('grp-useEOIDAsIdentityForGroupsAPIs') && groupId && tenantId) {
        prefixedId = `OID:${groupId}@${tenantId}`;
    }
    const additionalProperties = [
        UnifiedGroupDetailsAdditionalPropertyType.IsJoinRequestPendingApproval,
        UnifiedGroupDetailsAdditionalPropertyType.IsMembershipDynamic,
    ];

    if (isFeatureEnabled('grp-SendAsOnBehalfOfGrp')) {
        additionalProperties.push(UnifiedGroupDetailsAdditionalPropertyType.IsSendAsEnabled);
    }

    return getServiceAsync().then(service =>
        service.Operation.getUnifiedGroupDetailsOperation(
            {
                Header: getJsonRequestHeader(),
                Body: service.Factory.GetUnifiedGroupDetailsRequest({
                    ResponseShape: UnifiedGroupDetailsResponseShape.Full,
                    GroupIdentity: groupIdentity,
                    IncludeCapabilities: true,
                    AdditionalProperties: additionalProperties,
                }),
            },
            getGroupOwsOptions(groupSmtp, prefixedId)
        )
    );
}

export default function getGroupDetails(
    groupSmtp: string,
    groupId?: string,
    tenantId?: string
): Promise<GetUnifiedGroupDetailsJsonResponse> {
    return runOwsRequestWithMonitor({
        scenarioName: 'GetUnifiedGroupDetails',
        feature: Feature.UnifiedGroups,
        operation: () => createGroupDetailsRequest(groupSmtp, groupId, tenantId),
        transformResponse: (owsResponse: GetUnifiedGroupDetailsJsonResponse) => owsResponse,
    });
}
